module.exports = __webpack_public_path__ + "static/living-life-070a234ea99817bca790560cceaeab29.jpg";